import { useContext } from "react";
import { Fragment } from "react";
import Icon from "components/shared/Icon";
import Separator from "components/shared/Separator";
import Link from "components/shared/Link";
import { getLastPathSegment } from "utils/common";
import { Context } from "Context";

const MoreHelp = ({
	title,
	callToActions,
	primary,
	secondary,
	items,
	isMobileView,
	themes,
}) => {
	const {
		config: { brands, brand },
	} = useContext(Context);
	const linksToHide =
		brands[brand]?.hideSidebarLinks?.[getLastPathSegment()] || [];
	const iconsToHide =
		brands[brand]?.hideSidebarIcons?.[getLastPathSegment()] || [];
	const mainClass = "help-more";
	const themesModifier = themes
		? themes.map((theme) => ` ${mainClass}__content--${theme}`)
		: "";
	const renderTitle = () => {
		return (
			<div className={`${mainClass}__title`}>
				<h2>{title}</h2>
			</div>
		);
	};

	const renderList = (list) => {
		return (
			<ul className={`${mainClass}__list`}>
				{list.webLinkList.map((item, i) => {
					if (linksToHide.includes(item.href)){
						return null;
					}
					return (
						<li className={`${mainClass}__list__item`} key={i}>
							{item.href && <Link {...item} className={`${mainClass}__link`} />}
						</li>
					);
				})}
			</ul>
		);
	};

	const renderItems = (items) => {
		return (
			<ul className={`${mainClass}__list`}>
				{items.map((item, i) => {
					return (
						<li className={`${mainClass}__list__item`} key={i}>
							<div className={`${mainClass}__list__item__title`}>
								{item.title}
							</div>
							<div className={`${mainClass}__list__item__description`}>
								{item?.description}
							</div>
						</li>
					);
				})}
			</ul>
		);
	};

	return (
		<div className={mainClass}>
			{isMobileView && (
				<Fragment>
					<Separator />
					{renderTitle()}
				</Fragment>
			)}
			{!!callToActions.length && (
				<div className={`${mainClass}__icons`}>
					{callToActions.map((item) => {
						if (iconsToHide.includes(item.link.href)) return null;
						return (
							<Link
								{...item.link}
								className={`${mainClass}__icons--cta ${mainClass}__icons--${item.icon}`}
								key={item.id}
							>
								<span>{item.title}</span>
								<Icon icon={item.icon} loading={"eager"} />
							</Link>
						);
					})}
				</div>
			)}
			<div
				className={`${mainClass}__content${
					callToActions.length ? "" : ` ${mainClass}__content--empty-actions`
				}${themesModifier}`}
			>
				{!isMobileView && title && renderTitle()}
				{renderList(primary)}
				{renderItems(items)}
				{!!secondary.webLinkList.length && (
					<Fragment>
						<Separator />
						{renderList(secondary)}
					</Fragment>
				)}
			</div>
		</div>
	);
};

export default MoreHelp;
